var exports = {
  "zk": "x31de4314--7f46f3--gpt-banner",
  "Qq": "x31de4314--7f46f3--text",
  "h_": "x31de4314--7f46f3--description",
};

module.exports = exports;
